import { useContext } from 'react';
import { GameContext } from '../contexts/GameContext.tsx';
import Cell from './Cell.tsx';

export default function Grid() {
  const gameContext = useContext(GameContext);

  if (!gameContext) return null;

  return (
    <div 
      className="grid-container"
      style={{
        gridTemplateColumns: `repeat(${gameContext.config.gridSize}, 1fr)`
      }}
    >
      {gameContext.grid.map((row, rowIndex) => (
        row.map((cellState, colIndex) => (
          <Cell
            key={`${rowIndex}-${colIndex}`}
            state={cellState}
            row={rowIndex}
            col={colIndex}
          />
        ))
      ))}
    </div>
  );
} 